import UserAvatar from '../components/shared/UserAvatar';
import { NotificationForumComment } from '../../core/interfaces/notification.interface';

const ForumCommentNotification = ({ notification }: { notification: NotificationForumComment }) => {
  const u = notification?.comment?.user;
  return (
    <>
      <UserAvatar src={u?.avatar} name={u?.name} email={u?.email} />
      <div style={{ marginLeft: '5px', textWrap: 'wrap' }}>
        <div style={{ fontSize: '1rem', color: '#c4c4c4' }}>Nuevo comentario en Foro</div>
        <div>{`${u?.name || u?.email || 'Alguien'} comentó en ${notification?.forumSubject?.title ?? 'el foro'}`}</div>
        <div style={{ color: '#c2c2c2', height: '20px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {notification?.comment?.content}
        </div>
      </div>
    </>
  );
};

export default ForumCommentNotification;
